import { Bracket } from '../components/Bracket.js';
import { useApp } from '../store.js';
import { roundTitle } from '../strings.js';

/** Между матчами: сетка и что дальше. */
export function BracketScreen() {
  const t = useApp((s) => s.tournament);
  if (!t) return null;
  const next = t.matches.find((m) => m.status !== 'FINISHED' && [m.playerAId, m.playerBId].includes(t.youId));
  const waiting = next && (!next.playerAId || !next.playerBId);
  return (
    <main className="screen bracket-screen">
      <h1 className="screen__title">{roundTitle(t.round, t.size)}</h1>
      <p className="screen__lead">
        {!next
          ? 'Ждём результаты'
          : waiting
            ? `Вы прошли дальше: ${roundTitle(next.round, t.size).toLowerCase()}! Ждём соперника…`
            : 'Ваш матч вот-вот начнётся'}
      </p>
      <Bracket tournament={t} />
    </main>
  );
}
